/**
 * CollectorItems - lista zeskanowanych pozycji z edycja i statystykami.
 * Wyodrebniony z KolektorPage.jsx.
 */

import React from 'react';

const CollectorItems = ({
  currentSession,
  items,
  stats,
  editingItem, setEditingItem,
  loading,
  handleUpdateItem,
  handleDeleteItem,
  handlePauseSession,
  handleConvertToInventory,
  handleCreatePw,
  handleShowDeliveryReport,
}) => (
  <div>
    {/* Statystyki */}
    {currentSession && (
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '0.5rem',
        marginBottom: '1rem'
      }}>
        <div style={{
          backgroundColor: 'var(--card-bg)',
          padding: '0.75rem',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '20px', fontWeight: '700', color: 'var(--info)' }}>
            {stats.total_items || 0}
          </div>
          <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>Pozycji</div>
        </div>
        <div style={{
          backgroundColor: 'var(--card-bg)',
          padding: '0.75rem',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '20px', fontWeight: '700', color: 'var(--success)' }}>
            +{(stats.positive_difference || 0).toFixed(0)}
          </div>
          <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>Nadwyzki</div>
        </div>
        <div style={{
          backgroundColor: 'var(--card-bg)',
          padding: '0.75rem',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '20px', fontWeight: '700', color: 'var(--danger)' }}>
            {(stats.negative_difference || 0).toFixed(0)}
          </div>
          <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>Niedobory</div>
        </div>
      </div>
    )}

    {/* Lista pozycji */}
    {items.length === 0 ? (
      <div style={{
        textAlign: 'center',
        padding: '2rem',
        color: 'var(--text-muted)',
        backgroundColor: 'var(--card-bg)',
        borderRadius: '8px'
      }}>
        Brak pozycji. Przejdz do skanowania.
      </div>
    ) : (
      <div style={{
        backgroundColor: 'var(--card-bg)',
        borderRadius: '8px',
        overflow: 'hidden'
      }}>
        {items.map((item, index) => (
          <div
            key={item.id}
            style={{
              padding: '0.75rem',
              borderBottom: '1px solid var(--border)',
              backgroundColor: editingItem === item.id ? 'var(--bg)' : 'var(--card-bg)'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{
                minWidth: '28px',
                marginRight: '0.5rem',
                fontWeight: '600',
                fontSize: '12px',
                color: 'var(--text-muted)',
                textAlign: 'center',
                paddingTop: '2px'
              }}>
                {index + 1}.
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: '500', fontSize: '13px' }}>{item.product_name}</div>
                <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
                  {item.product_code} | {item.ean}
                </div>
              </div>
              <div style={{ textAlign: 'right', minWidth: '80px' }}>
                {editingItem === item.id ? (
                  <input
                    type="number"
                    defaultValue={item.scanned_count}
                    onBlur={(e) => handleUpdateItem(item.id, e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleUpdateItem(item.id, e.target.value)}
                    style={{
                      width: '70px',
                      padding: '4px',
                      fontSize: '14px',
                      textAlign: 'right',
                      border: '1px solid var(--info)',
                      borderRadius: '4px'
                    }}
                    autoFocus
                  />
                ) : (
                  <div
                    onClick={() => setEditingItem(item.id)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div style={{ fontWeight: '600', fontSize: '14px' }}>
                      {item.scanned_count} {item.unit}
                    </div>
                    <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
                      sys: {item.system_count}
                    </div>
                  </div>
                )}
              </div>
              <div style={{
                marginLeft: '0.5rem',
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '12px',
                fontWeight: '600',
                backgroundColor: item.difference > 0 ? 'var(--success-light)' : item.difference < 0 ? 'var(--danger-light)' : 'var(--border)',
                color: item.difference > 0 ? 'var(--success)' : item.difference < 0 ? 'var(--danger)' : 'var(--text-muted)'
              }}>
                {item.difference > 0 ? '+' : ''}{item.difference}
              </div>
              <button
                onClick={() => handleDeleteItem(item.id)}
                style={{
                  marginLeft: '0.5rem',
                  padding: '4px 8px',
                  backgroundColor: 'transparent',
                  color: 'var(--danger)',
                  
                  fontSize: '16px',
                  cursor: 'pointer'
                }}
              >
                &#215;
              </button>
            </div>
          </div>
        ))}
      </div>
    )}

    {/* Przyciski akcji */}
    {currentSession && currentSession.status !== 'converted' && items.length > 0 && (
      <div style={{
        marginTop: '1rem',
        display: 'flex',
        gap: '0.5rem'
      }}>
        <button
          onClick={handlePauseSession}
          style={{
            flex: 1,
            padding: '6px 12px',
            backgroundColor: 'var(--warning)',
            color: 'var(--text)',
            fontSize: '12px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          Wstrzymaj
        </button>
        {currentSession.inventory_type === 'pw' ? (
          <button
            onClick={handleCreatePw}
            disabled={loading}
            style={{
              flex: 1,
              padding: '6px 12px',
              border: '1px solid var(--info)', color: 'var(--info)',
              fontSize: '12px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Utworz PW
          </button>
        ) : currentSession.inventory_type === 'delivery_check' ? (
          <button
            onClick={handleShowDeliveryReport}
            disabled={loading}
            style={{
              flex: 1,
              padding: '6px 12px',
              border: '1px solid var(--warning)', color: 'var(--warning)',
              fontSize: '12px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Raport roznic
          </button>
        ) : (
          <button
            onClick={handleConvertToInventory}
            style={{
              flex: 1,
              padding: '6px 12px',
              border: '1px solid var(--purple)', color: 'var(--purple)',
              fontSize: '12px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Utworz inwenture
          </button>
        )}
      </div>
    )}
  </div>
);

export default CollectorItems;
